var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOriginMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33,11A20,20,0,1,0,53,31,20,20,0,0,0,33,11Zm0,32.65A12.27,12.27,0,1,1,45.24,31.38,12.27,12.27,0,0,1,33,43.65Z",
    transform: "translate(-13 -11)",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33,19.11A12.27,12.27,0,1,0,45.24,31.38,12.27,12.27,0,0,0,33,19.11Zm6.9,18.11a9.1,9.1,0,1,1-.64-12.85A9.1,9.1,0,0,1,39.87,37.22Z",
    transform: "translate(-13 -11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.87,37.22a9.1,9.1,0,1,1-.64-12.85A9.1,9.1,0,0,1,39.87,37.22Z",
    transform: "translate(-13 -11)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginMarker);
export default __webpack_public_path__ + "static/media/origin-marker.d06a5ace8f936d7f09427d37c3cd20fe.svg";
export { ForwardRef as ReactComponent };